import { useEffect, useMemo, useState } from 'react';
import RecentTransactions from './recentTransactions/recentTransactions';
import WeeklyBudget from './weeklyBudget/weeklyBudget';
import { useTranslation } from 'react-i18next';
import { usePage } from '../../context/PageContext';
import { DashboardTabs } from '../../constants/constants';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '../../hooks/useAnalytics';
import { AnalyticsPage } from '../../interface/analytics';
import CustomTabs from '../customTabs/customTabs';
import { useNavigationStack } from '../../context/NavigationStackContext';

const Dashboard = () => {
  const { t } = useTranslation();
  const { setTitle } = usePage();
  const location = useLocation();
  const { trackPage } = useAnalytics();
  const { updateTop } = useNavigationStack();
  const fromTab = Object.values(DashboardTabs).includes(location?.state?.fromTab)
    ? location.state.fromTab
    : DashboardTabs.recentTransactions;
  const [selectedTab, setSelectedTab] = useState<string>(fromTab);

  useEffect(() => {
    trackPage(AnalyticsPage.DASHBOARD);
  }, [trackPage]);
  const items = useMemo(
    () => [
      {
        key: DashboardTabs.recentTransactions,
        label: t('common:tab.recentTransactions'),
        children: <RecentTransactions />,
      },
      {
        key: DashboardTabs.weeklyBudget,
        label: t('common:tab.weeklyBudget'),
        children: <WeeklyBudget />,
      },
    ],
    [t],
  );

  useEffect(() => {
    setTitle(t('common:mainHeader.dashboard'));
  }, [t, setTitle]);

  useEffect(() => {
    updateTop({ fromTab: selectedTab });
  }, [selectedTab]);

  return (
    <div className="dashboard-wrapper">
      <CustomTabs
        data-testid="dashboard-tabs"
        activeKey={selectedTab}
        onChange={setSelectedTab}
        items={items}
      />
    </div>
  );
};

export default Dashboard;
